import { AnalyticsEventLocation } from 'services/analytics/entities';
import { locations } from 'services/routes/locations';

export const getEventLocation = (curentPathname: string) => {
  if (locations.library.pathname === curentPathname)
    return AnalyticsEventLocation.LIBRARY;
  if (locations.general.aiMusicGenerator.pathname === curentPathname)
    return AnalyticsEventLocation.AI_MUSIC_GENERATOR;
  if (locations.general.discovery.pathname === curentPathname)
    return AnalyticsEventLocation.DISCOVERY_PAGE;
  return AnalyticsEventLocation.MAIN_LIST;
};
